<div class="flex max-h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-center justify-between px-6 pb-4 pt-6">
    <div class="flex items-center gap-2">
      <mat-icon class="text-primary">calculate</mat-icon>
      <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.UNIT_CALCULATOR_MODAL.TITLE' | t }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- producto y unidad de venta (separados) -->
  <div class="bg-primary-50 px-6 py-4 dark:bg-primary-900/10">
    <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <div class="flex flex-col">
        <span class="text-secondary text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.PRODUCT' | t }}</span>
        <span class="text-primary text-base font-semibold">{{ data.item.code }} - {{ data.item.name }}</span>
      </div>
      <div class="flex flex-col">
        <span class="text-secondary text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.UNIT_CALCULATOR_MODAL.SALE_UNIT' | t }}</span>
        <span class="text-primary text-base font-semibold">{{ saleLabel }}</span>
      </div>
    </div>
  </div>

  <!-- cantidad a convertir -->
  <div class="px-6 py-4">
    <label class="text-secondary text-xs font-medium uppercase">
      {{ 'DOCUMENT_GENERATE.FIELDS.QUANTITY_IN' | t: { unit: fromUnit ? fromUnit.name : ('DOCUMENT_GENERATE.UNIT_CALCULATOR_MODAL.SELECTED_UNIT_FALLBACK' | t) } }}
    </label>
    <input type="text" inputmode="decimal" [ngModel]="amountText" (ngModelChange)="onAmountInput($event)"
      [disabled]="!fromUnitId" placeholder="0"
      class="mt-1 w-full rounded-lg border px-3 py-2 text-lg outline-none focus:border-primary disabled:opacity-50 dark:bg-transparent">
    @if (fromUnit && amount > 0) {
    <div class="mt-3 rounded-xl border border-primary-100 bg-primary-50 px-4 py-3 dark:border-primary-900/40 dark:bg-primary-900/10">
      <span class="text-secondary text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.UNIT_CALCULATOR_MODAL.EQUIVALENT_TO' | t }}</span>
      <div class="text-primary text-2xl font-bold">{{ converted | number:'1.0-3' }} {{ saleLabel }}</div>
      <div class="text-secondary text-sm">{{ amount | number:'1.0-3' }} {{ fromUnit.name }}</div>
    </div>
    }
  </div>

  <!-- lista de unidades -->
  <div class="min-h-0 flex-1 overflow-auto border-t px-6 py-4">
    <span class="text-secondary text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.UNIT_CALCULATOR_MODAL.UNIT_TO_CONVERT' | t }}</span>
    <mat-radio-group [(ngModel)]="fromUnitId" class="mt-2 flex flex-col gap-2">
      @for (u of units; track u.unitMeasureId) {
      <label class="flex cursor-pointer items-center justify-between rounded-xl border px-4 py-3 transition-colors"
        [ngClass]="fromUnitId === u.unitMeasureId ? 'border-primary bg-primary-50 dark:bg-primary-900/10' : 'hover:bg-gray-50 dark:hover:bg-gray-800/40'">
        <div class="flex items-center gap-3">
          <mat-radio-button [value]="u.unitMeasureId"></mat-radio-button>
          <div class="flex flex-col">
            <div class="flex items-center gap-2">
              <span class="text-base font-semibold">{{ u.name }} ({{ u.code }})</span>
              @if (u.chip === 'BASE') {
              <span class="rounded-full bg-green-100 px-2 py-0.5 text-xs font-semibold text-green-700 dark:bg-green-900/40 dark:text-green-300">{{ 'DOCUMENT_GENERATE.BADGES.BASE' | t }}</span>
              } @else if (u.chip === 'SECUNDARIA') {
              <span class="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">{{ 'DOCUMENT_GENERATE.BADGES.SECONDARY' | t }}</span>
              } @else if (u.chip === 'PARALELA') {
              <span class="rounded-full bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-700 dark:bg-blue-900/40 dark:text-blue-300">{{ 'DOCUMENT_GENERATE.BADGES.PARALLEL' | t }}</span>
              }
            </div>
            <span class="text-secondary text-sm">{{ u.equivalence }}</span>
          </div>
        </div>
      </label>
      } @empty {
      <div class="text-secondary flex h-32 items-center justify-center text-base">
        {{ 'DOCUMENT_GENERATE.MESSAGES.NO_ALTERNATE_UNITS' | t }}
      </div>
      }
    </mat-radio-group>
  </div>

  <!-- footer -->
  <div class="flex justify-end gap-3 border-t bg-gray-50 px-6 py-4 dark:bg-transparent">
    <button mat-stroked-button type="button" (click)="cancel()">{{ 'GENERAL.CANCEL' | t }}</button>
    <button mat-flat-button color="primary" type="button" [disabled]="!fromUnitId || converted <= 0" (click)="confirm()">
      {{ 'DOCUMENT_GENERATE.UNIT_CALCULATOR_MODAL.CONVERT' | t }}
    </button>
  </div>
</div>
